import axios from "axios";
import {url} from "../utilities";

const cookies = require('js-cookie');

class Readable {
    constructor(name) {
        this.name = name;
        this.key = name;

        this.read = window._read[this.key] ?? [];
    }

    setRead(id) {
        this.read = [...this.read, id];
        try {
            axios.post(url(`api/${this.key}/${id}/read`));
        } catch(err) {}
    }

    isRead(id) {
        return this.read.includes(id);
    }

    update() {
        cookies.set(this.key, JSON.stringify(this.read));
    }
}

export const dashboard_page = () => {
    let readables = [['message', 'messages'], ['event', 'events']];

    for(let readable of readables) {
        let singular = readable[0];
        let plural = readable[1];

        let obj = new Readable(plural);
        let unread = 0;

        let tabs = $(`#${plural}-tab`);

        $(`.${singular}-box[data-id]`).each(function () {
            let id = $(this).data('id');
            if (!obj.isRead(id)) {
                $(this).addClass('new')
                unread++;
            }

            $(this).hover(function () {
                if (!obj.isRead(id)) {
                    $(this).removeClass('new');
                    $(this).addClass('recently-read');
                    obj.setRead(id);
                    obj.update();

                    unread = unread - 1;
                    if (unread <= 0) {
                        tabs.find('.badge').hide();
                    } else {
                        tabs.find('.badge').show().find('.count').text(unread);
                    }
                }
            })
        })

        if (unread > 0) {
            tabs.find('.badge').show().find('.count').text(unread);
        }
    }
}
